import { call, put } from "redux-saga/effects";
import { resetApiError, riseError } from "store/features/general/general.actions";
import {
    createCreativeMapping as createCreativeMappingAPI,
    updateCreativeMapping as updateCreativeMappingAPI,
    deleteCreativeMapping as deleteCreativeMappingAPI,
    getCreativeMappings,
    CreativeMappings,
} from "api";
import {
    fetchCreativeMappings,
    createCreativeMapping,
    updateCreativeMapping,
    deleteCreativeMapping,
} from "./overview.actions";
import { buildCreativeMappingsViewModel, buildCreativeMappingModel } from "api/factories/creativeMappings.factory";
import { fetchCreativeMappingsFieldsSaga } from "store/features/filters";

export function* fetchCreativeMappingsSaga(headers: HeadersInit): Generator {
    try {
        const creativeMappings = (yield call(getCreativeMappings, headers)) as CreativeMappings[];
        // TODO: refactor fields definition and remove it from scheduler to upper reducer
        yield call(fetchCreativeMappingsFieldsSaga, headers);
        yield put(fetchCreativeMappings.success(buildCreativeMappingsViewModel(creativeMappings)));
    } catch (err) {
        if (err.status) {
            yield put(fetchCreativeMappings.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* createCreativeMappingSaga(
    headers: HeadersInit,
    action: ReturnType<typeof createCreativeMapping.request>
): Generator {
    try {
        yield call(createCreativeMappingAPI, buildCreativeMappingModel(action.payload), headers);
        yield put(createCreativeMapping.success());
        // TODO: refactor fields definition and remove it from scheduler to upper reducer
        yield call(fetchCreativeMappingsSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(createCreativeMapping.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* updateCreativeMappingSaga(
    headers: HeadersInit,
    action: ReturnType<typeof updateCreativeMapping.request>
): Generator {
    try {
        yield call(updateCreativeMappingAPI, buildCreativeMappingModel(action.payload), headers);
        // TODO: refactor fields definition and remove it from scheduler to upper reducer
        yield put(updateCreativeMapping.success());
        yield call(fetchCreativeMappingsSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(updateCreativeMapping.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* deleteCreativeMappingSaga(
    headers: HeadersInit,
    action: ReturnType<typeof deleteCreativeMapping.request>
): Generator {
    try {
        yield call(deleteCreativeMappingAPI, action.payload, headers);
        yield put(deleteCreativeMapping.success());
        yield call(fetchCreativeMappingsSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(deleteCreativeMapping.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
